import React from 'react';
import ReactLoading from 'react-loading';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  preloader: {
    margin: '0 auto',
    color: '#007336',
  },
}));

export function PreLoader(props) {
  const classes = useStyles();
  return <ReactLoading type="cylon" className={classes.preloader} />;
}
